"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactVirtualized = require("react-virtualized");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Holder = _styledComponents["default"].div.withConfig({
  displayName: "MobileAccordions__Holder",
  componentId: "sc-1a731o5-0"
})(["position:relative;*:focus{outline:none;}"]);
var SearchResultsHolder = _styledComponents["default"].div.withConfig({
  displayName: "MobileAccordions__SearchResultsHolder",
  componentId: "sc-1a731o5-1"
})(["overflow:visible;height:", "px;"], function (props) {
  return props.height;
});
var MobileAccordions = function MobileAccordions(_ref) {
  var holderHeight = _ref.holderHeight,
    data = _ref.data,
    accordion = _ref.accordion,
    scrollToIndex = _ref.scrollToIndex;
  var openAccordions = {};
  var list = (0, _react.useRef)();
  var CustomAccordion = accordion;
  var cellMeasurerCache = new _reactVirtualized.CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 100
  });
  var recompute = function recompute(index) {
    var interval = setInterval(function () {
      cellMeasurerCache.clear(index, 0);
      if (list && list.recomputeRowHeights) {
        list.recomputeRowHeights(index);
      }
    }, 10);
    setTimeout(function () {
      clearInterval(interval);
    }, 1500);
  };
  var accordionChanged = function accordionChanged(index, newState) {
    var value = _objectSpread({}, openAccordions);
    value[index] = newState;
    openAccordions = value;
  };
  var RowRenderer = function RowRenderer(_ref2) {
    var index = _ref2.index,
      key = _ref2.key,
      style = _ref2.style,
      parent = _ref2.parent;
    return _react["default"].createElement(_reactVirtualized.CellMeasurer, {
      key: key,
      cache: cellMeasurerCache,
      parent: parent,
      columnIndex: 0,
      rowIndex: index
    }, _react["default"].createElement("div", {
      className: "pb-2 mb-2",
      key: index,
      style: style,
      onClick: function onClick() {
        return recompute(index);
      }
    }, _react["default"].createElement(CustomAccordion, {
      data: data[index],
      index: index,
      startOpen: openAccordions[index],
      onClick: function onClick(newState) {
        return accordionChanged(index, newState);
      }
    })));
  };
  RowRenderer.propTypes = {
    index: _propTypes["default"].number.isRequired,
    key: _propTypes["default"].string.isRequired,
    style: _propTypes["default"].object.isRequired,
    parent: _propTypes["default"].any.isRequired
  };
  return _react["default"].createElement(Holder, null, _react["default"].createElement(SearchResultsHolder, {
    height: holderHeight
  }, data && data.length ? _react["default"].createElement(_reactVirtualized.AutoSizer, null, function (_ref3) {
    var width = _ref3.width;
    return _react["default"].createElement(_reactVirtualized.List, {
      ref: function ref(_ref4) {
        list = _ref4;
      },
      width: width,
      height: holderHeight,
      rowCount: data.length,
      rowHeight: cellMeasurerCache.rowHeight,
      rowRenderer: RowRenderer,
      scrollToIndex: scrollToIndex
    });
  }) : null));
};
MobileAccordions.propTypes = {
  holderHeight: _propTypes["default"].number.isRequired,
  data: _propTypes["default"].array.isRequired,
  accordion: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].node, _propTypes["default"].object]).isRequired,
  scrollToIndex: _propTypes["default"].number
};
MobileAccordions.defaultProps = {
  scrollToIndex: null
};
var _default = MobileAccordions;
exports["default"] = _default;